import { AxiosResponse } from 'axios';
import { saveState } from '../utils/saveUserState';
import apiClient from '../../../services/apiClient';
import uuid from '../../../services/uuid';

export const getRedirectURLRegister = (redirectUrl?: string, loginHint?: string) => {
  const payload = {
    host: window.location.host,
    state: uuid.generate(),
    ...(loginHint && { login_hint: loginHint }),
  };
  saveState(redirectUrl || '', payload.state);
  return apiClient.post<string>('/v1/register', payload).then(({ data }: AxiosResponse<string>) => {
    return data;
  });
};
